/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_road__detailed_instructions = /** @type {(inputs: {}) => string} */ () => {
	return `Detaillierte Anweisungen`
};

const en_road__detailed_instructions = /** @type {(inputs: {}) => string} */ () => {
	return `Detailed instructions`
};

const es_road__detailed_instructions = /** @type {(inputs: {}) => string} */ () => {
	return `Instrucciones detalladas`
};

const fr_road__detailed_instructions = /** @type {(inputs: {}) => string} */ () => {
	return `Instructions détaillées`
};

const it_road__detailed_instructions = /** @type {(inputs: {}) => string} */ () => {
	return `Istruzioni dettagliate`
};

const nl_road__detailed_instructions = /** @type {(inputs: {}) => string} */ () => {
	return `Gedetailleerde instructies`
};

const pt_road__detailed_instructions = /** @type {(inputs: {}) => string} */ () => {
	return `Instruções pormenorizadas`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const road__detailed_instructions = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.road__detailed_instructions(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("road__detailed_instructions", locale)
	if (locale === "de") return de_road__detailed_instructions(inputs)
	if (locale === "en") return en_road__detailed_instructions(inputs)
	if (locale === "es") return es_road__detailed_instructions(inputs)
	if (locale === "fr") return fr_road__detailed_instructions(inputs)
	if (locale === "it") return it_road__detailed_instructions(inputs)
	if (locale === "nl") return nl_road__detailed_instructions(inputs)
	return pt_road__detailed_instructions(inputs)
};